module.exports = __webpack_public_path__ + "static/media/IFIXIT Page.bc004cd1.PNG";